export default "__VITE_ASSET__eb842e2a__"